import { useEffect, useState } from "react";
import { Toaster } from "sonner";

const isLight = () => document.documentElement.classList.contains("light");

// Notificações que acompanham o tema ativo (cores por tipo: sucesso, erro, aviso, informação).
export default function ThemedToaster() {
  const [light, setLight] = useState(isLight);
  useEffect(() => {
    const obs = new MutationObserver(() => setLight(isLight()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return <Toaster theme={light ? "light" : "dark"} position="top-right" richColors />;
}
